import { PageHeader } from '@/components/PageHeader';

export const ProfileDetailsSkeleton = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader className="pl-4">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 animate-pulse rounded-md bg-gray-200" />
          <div>
            <div className="mb-1 h-4 w-12 animate-pulse rounded bg-gray-200" />
            <div className="h-8 w-48 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="h-9 w-20 animate-pulse rounded-md bg-gray-200" />
        </div>
      </PageHeader>

      <div className="mx-auto max-w-5xl px-4 py-8">
        <div className="rounded-lg border bg-white p-8">
          {/* Profile Details Grid Skeleton */}
          <div className="mb-10 grid grid-cols-2 gap-x-8 gap-y-4">
            {Array.from({ length: 7 }).map((_, index) => (
              <div key={index} className="mb-2">
                <div className="mb-2 h-4 w-24 animate-pulse rounded bg-gray-200" />
                <div className="h-5 w-32 animate-pulse rounded bg-gray-200" />
              </div>
            ))}
          </div>

          {/* Advanced Settings Skeleton */}
          <div className="mb-10">
            <div className="mb-4 h-6 w-40 animate-pulse rounded bg-gray-200" />
            <div className="grid grid-cols-2 gap-x-8 gap-y-4">
              <div>
                <div className="mb-2 h-4 w-32 animate-pulse rounded bg-gray-200" />
                <div className="space-y-2">
                  <div className="h-4 w-40 animate-pulse rounded bg-gray-200" />
                  <div className="h-4 w-36 animate-pulse rounded bg-gray-200" />
                  <div className="h-4 w-28 animate-pulse rounded bg-gray-200" />
                </div>
              </div>
              <div>
                <div className="mb-2 h-4 w-28 animate-pulse rounded bg-gray-200" />
                <div className="h-4 w-44 animate-pulse rounded bg-gray-200" />
                <div className="mt-4">
                  <div className="mb-2 h-4 w-36 animate-pulse rounded bg-gray-200" />
                  <div className="h-4 w-40 animate-pulse rounded bg-gray-200" />
                </div>
              </div>
            </div>
          </div>

          {/* Users Table Skeleton */}
          <div>
            <div className="mb-4 h-6 w-32 animate-pulse rounded bg-gray-200" />
            <div className="rounded-lg border">
              {/* Table Header */}
              <div className="border-b bg-gray-50 p-4">
                <div className="grid grid-cols-4 gap-4">
                  <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
                  <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
                  <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
                  <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
                </div>
              </div>
              {/* Table Rows */}
              {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="border-b p-4 last:border-b-0">
                  <div className="grid grid-cols-4 gap-4">
                    <div className="h-4 w-28 animate-pulse rounded bg-gray-200" />
                    <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
                    <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
                    <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
                  </div>
                </div>
              ))}
            </div>
            {/* Pagination Skeleton */}
            <div className="mt-4 flex items-center justify-between">
              <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
              <div className="flex gap-2">
                <div className="h-8 w-20 animate-pulse rounded bg-gray-200" />
                <div className="h-8 w-8 animate-pulse rounded bg-gray-200" />
                <div className="h-8 w-8 animate-pulse rounded bg-gray-200" />
                <div className="h-8 w-20 animate-pulse rounded bg-gray-200" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
